import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import { SSO_ARTICLE_URL } from '../constants';

export default function SsoForm({ email, error, loading, onEmailChange, onBack, onSubmit }) {
    const handleSubmit = e => { e.preventDefault(); onSubmit(); };
    return (
        <form className="registration-form" onSubmit={handleSubmit}>
            {error ? (
                <div className="error-msg boxPadding"><span className="error-msg-text">{error}</span></div>
            ) : null}
            <div className="form-group">
                <label htmlFor="sso-login-email"><Translate id="STATIC.PAGES.LOGIN.EMAIL" /></label>
                <input
                    id="sso-login-email" type="email" className="form-control" placeholder="name@company.com" autoFocus
                    value={email} onChange={e => onEmailChange(e.target.value)}
                />
            </div>
            <button type="submit" className="btn btn-block btn-singular btn-primary" disabled={loading}>
                <Translate id="STATIC.PAGES.LOGIN.SSO_SUBMIT" />
            </button>
            <a className="form-underlink pull-left" href="#" onClick={e => { e.preventDefault(); onBack(); }}>
                <Translate id="STATIC.PAGES.LOGIN.BACK_TO_LOGIN" />
            </a>
            <a className="form-underlink pull-right what-is-sso" href={SSO_ARTICLE_URL} target="_blank" rel="noopener noreferrer">
                <Translate id="STATIC.PAGES.LOGIN.WHAT_IS_SSO" />
            </a>
        </form>
    );
}

SsoForm.propTypes = {
    email: PropTypes.string.isRequired,
    error: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    onEmailChange: PropTypes.func.isRequired,
    onBack: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
};
